module.exports = __webpack_public_path__ + "static/img/group-7.4381b63e.png";